export class Mensagens {
  arquivo = "";
  bairro= "";
  cep= "";
  cgcCpf= "";
  cidade= "";
  createdAt= "";
  email= "";
  endereco= "";
  estado= "";
  formulario= "";
  id= "";
  interesse= "";
  mensagem= "";
  necessidade= "";
  nome= "";
  nota = "";
  produto = "";
  protocolo = "";
  razao = "";
  telefone = ""
}
